export const THEME_MODE = {
	LIGHT: 'light',
	DARK: 'dark',
	SYSTEM: 'auto',
};
